var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    id: "svg_1",
    fill: "#ff0000",
    r: 35,
    cy: 35.000098,
    cx: 35.124889
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_3",
    y2: 50.453027,
    x2: 49.749878,
    y1: 19.453027,
    x1: 19.749878,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 5,
    stroke: "white",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-91.98578643798828 34.762344360351555,34.9532241821289) ",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_7",
    y2: 50.453223,
    x2: 49.762346,
    y1: 19.453223,
    x1: 19.762346,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 5,
    stroke: "white",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.b08b4ea1b91404a245d14c5eeb5e36af.svg";
export { ForwardRef as ReactComponent };